// Copyright 2018 Sorama B.V.

// Solution based on:
// https://stackoverflow.com/questions/48904240/font-awesome-5-icons-class-binding-change-doesnt-affect-the-icon

import { bindable, customElement, inject, inlineView } from "aurelia-framework";

/**
 * A FontAwesome icon in an <i> element cannot handle the aurelis observer (FA is overwriting it). By using this control, it is possible.
 */
@inject(Element)
@customElement("fa-icon")
@inlineView("<template></template>")
export class FaIcon {
    @bindable
    public icon: string;

    @bindable
    public iconStyle: string;

    @bindable
    public dataFaTransform: string;

    private element: HTMLElement;
    private live: boolean;

    constructor(element) {
        this.element = element;
    }

    private dataFaTransformChanged(newTransform: string): void {
        if (!this.live) {
            return;
        }

        this.rebuild(this.icon, newTransform, this.iconStyle);
    }

    private iconChanged(newIcon: string): void {
        if (!this.live) {
            return;
        }

        this.rebuild(newIcon, this.dataFaTransform, this.iconStyle);
    }

    private iconStyleChanged(newStyle: string): void {
        if (!this.live) {
            return;
        }

        this.rebuild(this.icon, this.dataFaTransform, newStyle);
    }

    private attached(): void {
        this.live = true;
        this.rebuild(this.icon, this.dataFaTransform, this.iconStyle);
    }

    private detached(): void {
        this.live = false;
    }

    private rebuild(iconClass: string, dataTransform: string = null, iconStyle: string): void {
        if (!iconClass) {
            this.element.innerHTML = "";
            return;
        }

        let content = `<i class="${iconClass}"`;

        if (dataTransform) {
            content += ` data-fa-transform=="${dataTransform}"`;
        }

        if (iconStyle) {
            content += ` style="${iconStyle}"`;
        }

        content += "></i>";

        this.element.innerHTML = content;
    }
}
